"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const lib_1 = require("apollo-cache-inmemory/lib");
const cache = new lib_1.InMemoryCache();
exports.default = cache;